import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { useEffect, useState } from "react";
import { PARTNER_STATUS_LABELS } from "../constants/partnerEnums";
import { toSelectOptions } from "../constants/commissionEnums";

const PartnerStatusDialog = ({ open, onClose, partner, onSubmit, saving }) => {
  const [status, setStatus] = useState("");
  const [submitError, setSubmitError] = useState(null);

  useEffect(() => {
    if (open && partner) {
      setStatus(partner.status || "PendingActivation");
      setSubmitError(null);
    }
  }, [open, partner]);

  const handleSubmit = async () => {
    const result = await onSubmit(status);
    if (result?.error) setSubmitError(result.error);
  };

  if (!partner) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>تغییر وضعیت نماینده #{partner.id}</DialogTitle>
      <DialogContent dividers>
        {submitError ? (
          <Alert severity="error" sx={{ mb: 2 }}>
            {submitError}
          </Alert>
        ) : null}
        <FormControl fullWidth sx={{ mt: 1 }}>
          <InputLabel>وضعیت</InputLabel>
          <Select value={status} label="وضعیت" onChange={(e) => setStatus(e.target.value)}>
            {toSelectOptions(PARTNER_STATUS_LABELS).map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          انصراف
        </Button>
        <Button variant="contained" onClick={handleSubmit} disabled={saving}>
          {saving ? "در حال ذخیره..." : "ذخیره"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PartnerStatusDialog;
